import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <section className="pt-20 md:pt-24 pb-8 md:pb-12 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-2 mb-4">
              <a href="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1">
                <i className="ri-home-line w-3 h-3 flex items-center justify-center" /> Home
              </a>
              <span className="text-foreground-300">/</span>
              <span className="text-xs text-primary-600 font-medium">Terms</span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
              Terms of <span className="text-primary-500">Service</span>
            </h1>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl border border-background-200 p-6 md:p-8 lg:p-10">
              <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed">
                <p className="mb-4">
                  Welcome to CSSBuyBR.info. These Terms of Service govern your use of our website. By accessing and using this website, you accept and agree to be bound by these terms.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Use of the Website</h2>
                <p className="mb-4">
                  This website is provided for informational and educational purposes only. You may use the content for personal, non-commercial research purposes. You may not reproduce, distribute, or modify the content without prior written permission.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Intellectual Property</h2>
                <p className="mb-4">
                  All content on this website, including text, images, and design elements, is the property of CSSBuyBR.info unless otherwise stated. Unauthorized use of any materials may violate copyright, trademark, and other laws.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">External Links</h2>
                <p className="mb-4">
                  This website contains links to external websites, including CSSBuy and other third-party services. We do not control these external sites and are not responsible for their content, privacy policies, or practices. Your use of external links is at your own risk.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">No Warranty</h2>
                <p className="mb-4">
                  This website and its content are provided on an "as is" basis without any warranties of any kind. We do not guarantee the accuracy, completeness, or reliability of any information on this site. Use the information at your own discretion.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Limitation of Liability</h2>
                <p className="mb-4">
                  In no event shall CSSBuyBR.info be liable for any damages arising from the use or inability to use this website, even if we have been advised of the possibility of such damages. This includes but is not limited to direct, indirect, incidental, or consequential damages.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Changes to Terms</h2>
                <p className="mb-4">
                  We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of the website after changes constitutes acceptance of the new terms.
                </p>
                <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg mt-8">
                  <p className="text-sm text-amber-800">
                    Last updated: August 30, 2026. If you do not agree to these terms, please discontinue use of this website immediately.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}